import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqItems } from '@/mocks/cinemaData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="访问前最常被问到的几个问题"
          desc="把访问方式、浏览器观看与客户端相关的疑问集中在这里，点击条目即可展开答案，再次点击收起。"
        />

        <div className="mt-10 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-50 md:px-6"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{item.q}</span>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                      aria-hidden="true"
                    />
                  </button>
                </h3>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}